import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperPlane = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M1.444 1.252a.6.6 0 0 0-.762.85L4.705 9 .682 15.898a.6.6 0 0 0 .762.85l16.2-7.2a.6.6 0 0 0 0-1.096zm4.37 7.268-3.16-5.417L15.924 9 2.655 14.897l3.16-5.417H10.8a.48.48 0 1 0 0-.96H5.815Z",
		clipRule: "evenodd"
	})
});
const Memo = memo(SvgPaperPlane);
export default Memo;
